import { getCurrentUser } from "./utils/current-user";
const headers = {
    'Content-Type': 'application/json',
    'X-Skanfil-Lang': document.body.dataset.uiculture,
};
function getRequestValidationToken() {
    const elements = document.getElementsByName("__RequestVerificationToken");
    if (elements.length == 0)
        return "";
    return elements[0].value;
}
async function fetchRequest(method, url, data, signal) {
    var _a;
    const currentUser = getCurrentUser();
    const requestHeaders = {
        ...headers,
    };
    requestHeaders['X-User-Token'] = (_a = currentUser.accessToken) !== null && _a !== void 0 ? _a : "";
    const verificationToken = getRequestValidationToken();
    if (method === 'POST' && verificationToken) {
        requestHeaders['X-RequestVerificationToken'] = verificationToken;
    }
    const options = {
        method,
        headers: {
            ...requestHeaders,
        },
        body: data ? JSON.stringify(data) : undefined,
        signal
    };
    const res = await fetch(url, options);
    if (res.status === 401) {
        throw {
            status: res.status,
            data: {
                Message: 'Feil epostadresse eller passord'
            }
        };
    }
    if (res.status === 204) {
        return null;
    }
    if (res.status !== 200) {
        const data = await res.json();
        throw {
            status: res.status,
            data
        };
    }
    return await res.json();
}
export class ApiClient {
    constructor(endpoint) {
        this.endpoint = endpoint;
    }
    post(url, data) {
        return fetchRequest('POST', this.endpoint + url, data);
    }
    get(url, abort) {
        return fetchRequest('GET', this.endpoint + url, null, abort);
    }
    put(url, data) {
        return fetchRequest('PUT', this.endpoint + url, data);
    }
    delete(url, data) {
        return fetchRequest('DELETE', this.endpoint + url, data);
    }
}
export function objectToQueryString(query) {
    return Object
        .entries(query)
        .filter((v) => v[1] != undefined)
        .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
        .join('&');
}
